import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ValorDaObraService {
  valorDe() {
    const valorDe = [
      { id: 1000000, description: 'R$ 1.000.000,00' },
      { id: 6000000, description: 'R$ 6.000.000,00' },
      { id: 11000000, description: 'R$ 11.000.000,00' },
      { id: 16000000, description: 'R$ 16.000.00,00' },
      { id: 21000000, description: 'R$ 21.000.000,00' },
      { id: 26000000, description: 'R$ 26.000.000,00' },
      { id: 31000000, description: 'R$ 31.000.000,00' },
      { id: 36000000, description: 'R$ 36.000.000,00' },
      { id: 41000000, description: 'R$ 41.000.000,00' },
      { id: 46000000, description: 'R$ 46.000.000,00' },
      { id: 51000000, description: 'R$ 51.000.000,00' },
      { id: 56000000, description: 'R$ 56.000.000,00' },
      { id: 61000000, description: 'R$ 61.000.000,00' },
      { id: 66000000, description: 'R$ 66.000.000,00' },
      { id: 71000000, description: 'R$ 71.000.000,00' },
      { id: 76000000, description: 'R$ 76.000.000,00' },
      { id: 81000000, description: 'R$ 81.000.000,00' },
      { id: 86000000, description: 'R$ 86.000.000,00' },
      { id: 91000000, description: 'R$ 91.000.000,00' },
      { id: 96000000, description: 'R$ 96.000.000,00' },
    ];
    return of(valorDe);
  }
  valorAte() {
    const valorAte = [
      { id: 1000000, description: 'R$ 1.000.000,00' },
      { id: 6000000, description: 'R$ 6.000.000,00' },
      { id: 11000000, description: 'R$ 11.000.000,00' },
      { id: 16000000, description: 'R$ 16.000.00,00' },
      { id: 21000000, description: 'R$ 21.000.000,00' },
      { id: 26000000, description: 'R$ 26.000.000,00' },
      { id: 31000000, description: 'R$ 31.000.000,00' },
      { id: 36000000, description: 'R$ 36.000.000,00' },
      { id: 41000000, description: 'R$ 41.000.000,00' },
      { id: 46000000, description: 'R$ 46.000.000,00' },
      { id: 51000000, description: 'R$ 51.000.000,00' },
      { id: 56000000, description: 'R$ 56.000.000,00' },
      { id: 61000000, description: 'R$ 61.000.000,00' },
      { id: 66000000, description: 'R$ 66.000.000,00' },
      { id: 71000000, description: 'R$ 71.000.000,00' },
      { id: 76000000, description: 'R$ 76.000.000,00' },
      { id: 81000000, description: 'R$ 81.000.000,00' },
      { id: 86000000, description: 'R$ 86.000.000,00' },
      { id: 91000000, description: 'R$ 91.000.000,00' },
      { id: 96000000, description: 'R$ 96.000.000,00' },
    ];
    return of(valorAte);
  }
}
